// extracted by mini-css-extract-plugin
export var postGrid = "v_bp";
export var wpPageLayout = "v_bn";
export var wpPageRelatedGrid = "v_bq";
export var wpPageRoot = "v_bm";